// Sidebar

// Default
import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";

// Mui
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { Divider, Stack, Typography, Tooltip, Popover } from "@mui/material";

// Svg
import Dashboard from "../../assets/svg/sidebar/Dashboard";
import Customer from "../../assets/svg/sidebar/Consumer Management";
import Meter2 from "../../assets/svg/sidebar/Meter Management";
import Read from "../../assets/svg/sidebar/Read Management";
import Vee from "../../assets/svg/sidebar/Rule Builder";
import Billing from "../../assets/svg/sidebar/Billing Management";
import Tickets from "../../assets/svg/sidebar/Tickets";
import Report from "../../assets/svg/sidebar/Reports";
import P2p from "../../assets/svg/sidebar/P2P";
import Settings from "../../assets/svg/sidebar/Settings";
import AiOutlineException from "../../assets/svg/sidebar/Exception Management";
import MdWebAsset from "../../assets/svg/sidebar/Asset Management";
import IoIosGitNetwork from "../../assets/svg/sidebar/Network Management";
import ChartNoAxesCombinedIcon from "../../assets/svg/sidebar/Analytics";
import MdWorkOutline from "../../assets/svg/sidebar/WorkOrders";
import MapPinned from "../../assets/svg/sidebar/Service Utility";

import MaskGroup from "../../assets/images/Mask group.png";

import { ExpandLess, ExpandMore } from "@mui/icons-material";

type SidebarList =
  | {
      icon: JSX.Element;
      menu: string;
      link: string;
      subMenu?: undefined;
    }
  | {
      icon: JSX.Element;
      menu: string;
      subMenu: {
        title: string;
        link: string;
      }[];
      link?: undefined;
    }
  | {
      icon: JSX.Element;
      menu: string;
      link: string;
      subMenu: {
        title: string;
        link: string;
      }[];
    };

const hasActivePath = (data: SidebarList, pathname: string) => {
  if (data?.subMenu) {
    // Check if any submenu item's link matches the pathname
    return data.subMenu.some((sub) => sub.link === pathname);
  } else {
    // Check if the top-level link matches the pathname
    return data?.link === pathname;
  }
};

const SIDEBAR: SidebarList[] = [
  //   icon: <Home />,
  //   menu: "Home",
  //   link: "/dashboard-360",
  // },
  {
    icon: <Dashboard />,
    menu: "Dashboard",
    link: "/dashboard-360",
  },
  {
    icon: <Customer />,
    menu: "Consumer Management (360)",
    link: "/consumer-360",
    // subMenu: [
    //   // { title: "Consumer360", link: "/consumer-dashboard" },
    //   { title: "Consumer 360", link: "/consumer-360" },
    //   // { title: "Consumer", link: "/consumer" },
    //   { title: "Consumers", link: "/consumer" },
    //   // { title: "Site", link: "/site" },
    //   // { title: "Location", link: "/location" },
    //   // { title: "Commitment Contract", link: "/commitment" },
    // ],
  },
  {
    icon: <Meter2 />,
    menu: "Meter Management",
    subMenu: [
      { title: "Meters", link: "/meters" },
      // { title: "Meter360", link: "/meter-dashboard" },
      { title: "Meter360", link: "/meter-dashboard" },
      { title: "Meter Profile", link: "/meter-type" },
      // { title: "Install Meter", link: "" },
      // { title: "Register Type", link: "" },
      // { title: "Register Rules", link: "/register-rules" },
      // { title: "Register Rule Book", link: "/register-rule-book" },
      // { title: "Register Rule Mixer", link: "" },
    ],
  },
  // {
  //   icon: <Read />,
  //   menu: "Read Management",
  //   subMenu: [
  //     { title: "Read", link: "" },
  //     { title: "Read Cluster", link: "/read-cluster" },
  //     // { title: "Read Cluster Mock", link: "/read-cluster-mock" },
  //   ],
  // },
  {
    icon: <Vee />,
    menu: "VEE Rule Builder",
    link: "/vee-rule-builder",
    // subMenu: [
    //   { title: "VEE Cluster", link: "/vee-cluster" },
    //   { title: "VEE Rules", link: "/vee-rules" },
    //   { title: "VEE Rule Builder", link: "/vee-rule-builder" },
    //   { title: "VEE Rule Workflow", link: "/vee-rule-workflow" },
    // ],
  },
  {
    icon: <Billing />,
    menu: "Billing Management",
    subMenu: [
      // { title: "Billing Determinants", link: "/billing-determinant" },
      // { title: "Billing Cluster", link: "" },
      // { title: "Wallet Balance", link: "/wallet-balance" },
      // {
      //   title: "Payment Processing Dashboard",
      //   link: "/payment-processing-dashboard",
      // },
      // { title: "Bill Generation System", link: "/bill-generation-system" },
      // { title: "Tariffs", link: "/tariffs" },
      { title: "Tariffs", link: "/new-tariffs" },
      { title: "Bills", link: "/billing-v2" },
      { title: "Payment", link: "/payments-v2" },
      { title: "Adjustments", link: "/adjustments-v2" },
      { title: "Billing Rules", link: "/billing-rule-builder" },
      // {
      //   title: "Rate Management Dashboard",
      //   link: "/rate-management-dashboard",
      // },
      // {
      //   title: "Collections Management Dashboard",
      //   link: "/collections-management-dashboard",
      // },
    ],
  },

  // {
  //   icon: <Tickets />,
  //   menu: "Tickets",
  //   link: "/tickets",
  // },

  // {
  //   icon: <AiOutlineException />,
  //   menu: "Exception Management",
  //   subMenu: [{ title: "Exception Management", link: "" }],
  // },

  // {
  //   icon: <MdWebAsset />,
  //   menu: "Asset Management",
  //   subMenu: [
  //     { title: "Assets Dashboard", link: "" },
  //     { title: "Enhanced Inventory", link: "" },
  //     { title: "Assets Reports", link: "" },
  //     { title: "Lifecycle Config", link: "" },
  //     { title: "Assets Details", link: "" },
  //     { title: "Maintenance Scheduling", link: "" },
  //   ],
  // },

  // {
  //   icon: <IoIosGitNetwork />,
  //   menu: "Network Management",
  //   link: "",
  // },
  // {
  //   icon: <ChartNoAxesCombinedIcon />,
  //   menu: "Analytics",
  //   link: "/analytics",
  // },

  {
    icon: <Report />,
    // link: "/reports",
    menu: "Advanced Reports",
    subMenu: [
      { title: "AMI Performance Report", link: "" },
      {
        title: "Billing Determinant Report",
        link: "/billing-determinant-report",
      },
      { title: "Billing Report", link: "/billing-report" },
      { title: "Billing Summary", link: "/billing-summary" },
      { title: "CAIDI Report", link: "/caidi-report" },
      { title: "CAIFI Report", link: "/caifi-report" },
      { title: "Consumption variance", link: "" },
      {
        title: "Daily Data Collection Report",
        link: "/daily-data-collection-report",
      },
      { title: "DER Integration Dashboard", link: "" },
      {
        title: "Energy Audit/Loss Report",
        link: "/energy-audit-loss-report",
      },

      {
        title: "Energy Performance Report",
        link: "/energy-performance-report",
      },
      { title: "Estimation Failure Detail Report", link: "" },
      { title: "Exception Report", link: "" },
      { title: "Excessive Missing Reads Report", link: "" },
      { title: "Interface Exception Report", link: "" },
      {
        title: "Interface Performance Report",
        link: "/interfaceperformancereport",
      },
      { title: "Load Forecasting Report", link: "" },
      { title: "Load Profile Data Report", link: "/load-profile-report" },
      { title: "MAIFI Report", link: "" },
      { title: "Meter Command Report", link: "" },
      { title: "Meter Event Report", link: "/meter-event-report" },
      { title: "Meter Inventory Report", link: "" },
      { title: "Meter Reading Report", link: "/meter-reading-report" },
      { title: "Midnight Consumption Report", link: "" },
      { title: "Missing Interval Aging Report", link: "" },
      { title: "Missing Reads Dashboard", link: "/missing-reads-dashboard" },
      { title: "Missing Reads Report", link: "" },
      {
        title: "Monthly Consumption Report",
        link: "/monthly-consumption-report",
      },
      { title: "MDM Performance Report", link: "" },
      { title: "No Reads Dashboard", link: "" },
      { title: "Physical Meter Events Report", link: "" },
      { title: "Reconciliation Report", link: "" },
      { title: "Reporting Dashboard", link: "" },
      { title: "Revenue Protection Report", link: "" },
      { title: "SAIDI Report", link: "/saidi-report" },
      { title: "SAIFI Report", link: "/saifi-report" },
      { title: "Theft Flags Report", link: "" },
      { title: "Unexpected Reads Dashboard", link: "" },
      { title: "Unauthorized Usage Report", link: "" },
      { title: "VEE Exceptions Report", link: "/vee-exceptions-report" },
      { title: "Weather Report", link: "" },
    ],
  },
  // {
  //   icon: <Report />,
  //   menu: "Reports V2",
  //   subMenu: [
  //     { title: "Overview", link: "/reports-v2/overview" },
  //     { title: "Consumption", link: "/reports-v2/consumption" },
  //     { title: "Revenue & Billing", link: "/reports-v2/revenue-billing" },
  //     { title: "Billing Analytics", link: "/reports-v2/billing-analytics" },
  //     { title: "Power Quality", link: "/reports-v2/power-quality" },
  //     {
  //       title: "Predictive Analytics",
  //       link: "/reports-v2/predictive-analytics",
  //     },
  //   ],
  // },
  {
    icon: <Report />,
    menu: "Analytics",
    subMenu: [
      { title: "Dashboard", link: "/report-analytics/dashboard" },
      { title: "Consumption", link: "/report-analytics/timeseries" },
      { title: "Anomaly Detection", link: "/report-analytics/anomalies" },
      { title: "Load Profile", link: "/report-analytics/load-profile" },
      { title: "Forecast", link: "/report-analytics/forecast" },
      { title: "Voltage Quality", link: "/report-analytics/voltage" },
      { title: "Frequency", link: "/report-analytics/frequency" },
      { title: "Demand Peaks", link: "/report-analytics/demand" },
      { title: "Event Log", link: "/report-analytics/events" },
      { title: "Compare Meters", link: "/report-analytics/compare" },
      { title: "Uptime", link: "/report-analytics/uptime" },
      { title: "Solar", link: "/report-analytics/solar" },
    ],
  },
  {
    icon: <MdWorkOutline />,
    menu: "Workorders",
    link: "/workorders",
    // subMenu: [
    //   { title: "Disconnect Meter", link: "" },
    //   { title: "Reconnect Meter", link: "" },
    //   { title: "On Demand Read", link: "" },
    // ],
  },

  // {
  //   icon: <UnifiedIcon icon={MdOutlineEventSeat} color="#000000" />,
  //   menu: "Events",
  //   link: "/events",
  // },

  {
    icon: <Settings />,
    menu: "Settings",
    subMenu: [
      { title: "User Management", link: "" },
      { title: "Group Management", link: "" },
      {
        title: "Notification & Alert Settings",
        link: "/notification-settings",
      },
    ],
  },
  {
    icon: <P2p />,
    menu: "P2P",
    subMenu: [
      { title: "Prosumer Dashboard", link: "/prosumer-dashboard" },
      { title: "Prosumer Scheduling", link: "/prosumer-scheduling" },
      { title: "Consumer Registration", link: "/consumer-registration" },
      { title: "Service Provider", link: "/service-provider" },
      { title: "Real Time Dashboard", link: "/real-time-dashboard" },
      { title: "Energy Block Dashboard", link: "/energy-block-dashboard" },
    ],
  },
  {
    icon: <ChartNoAxesCombinedIcon />,
    menu: "Basic Reports",
    link: "/basic-reports",
  },
  {
    icon: <MapPinned />,
    menu: "Field Service Utility",
    link: "/field-utility-service",
  },
];

const Sidebar = ({
  sidebarOpen,
  setSidebarOpen,
}: {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}) => {
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [miniOpenIndex, setMiniOpenIndex] = useState<number | null>(null);
  const [miniAnchorEl, setMiniAnchorEl] = useState<HTMLElement | null>(null);
  const openHoverTimerRef = useRef<number | null>(null);
  const closeHoverTimerRef = useRef<number | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath =
    location.pathname === "/" ? "/dashboard-360" : location.pathname;

  const { environment } = useAppSelector((state) => state.auth);

  const filteredSidebar = SIDEBAR.map((item) => {
    if (
      item.menu === "Billing Management" &&
      environment !== "Demo" &&
      item.subMenu
    ) {
      return {
        ...item,
        subMenu: item.subMenu.filter(
          (sub) => !["New Tariffs"].includes(sub.title),
        ),
      } as SidebarList;
    } else if (
      item.menu === "Settings" &&
      environment !== "Demo" &&
      item.subMenu
    ) {
      return {
        ...item,
        subMenu: item.subMenu.filter(
          (sub) => !["User Management", "Group Management"].includes(sub.title),
        ),
      } as SidebarList;
    }
    return item;
  }).filter((item) => {
    if (environment === "Test") {
      return ![
        "Read Management",
        "VEE Rule Builder",
        "Exception Management",
        "Asset Management",
        "Network Management",
        "Analytics",
        "Reports",
        "Advanced Reports",
        "P2P",
        "Field Service Utility",
      ].includes(item.menu);
    }
    return true;
  });

  const handleMouseEnter = (index: number) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(-1);
  };

  const handleClick = (index: number, text: any) => {
    if (text.subMenu) {
      if (text.link) {
        navigate(text.link);
      }
      setOpenIndex(openIndex === index ? null : index);
    } else {
      navigate(text.link);
    }
  };

  const handleNavigate = (route: string) => {
    if (route) {
      navigate(route);
    } else {
      alert("Coming soon....");
    }
  };

  const scheduleOpen = (idx: number, el: HTMLElement) => {
    if (closeHoverTimerRef.current)
      window.clearTimeout(closeHoverTimerRef.current);
    if (openHoverTimerRef.current)
      window.clearTimeout(openHoverTimerRef.current);
    openHoverTimerRef.current = window.setTimeout(() => {
      setMiniOpenIndex(idx);
      setMiniAnchorEl(el);
    }, 80);
  };

  const scheduleClose = () => {
    if (openHoverTimerRef.current)
      window.clearTimeout(openHoverTimerRef.current);
    if (closeHoverTimerRef.current)
      window.clearTimeout(closeHoverTimerRef.current);
    closeHoverTimerRef.current = window.setTimeout(() => {
      setMiniOpenIndex(null);
      setMiniAnchorEl(null);
    }, 150);
  };

  return (
    <div>
      <Drawer
        open={sidebarOpen}
        PaperProps={{
          sx: {
            paddingTop: "0px",
            backgroundColor: "#fff",
            opacity: 1,
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
          },
        }}
        className="sidebar-wrapper"
        onClose={() => setSidebarOpen(false)}
      >
        <Box
          sx={{ width: 350, mx: 1 }}
          className="sidebar-wrapper"
          role="presentation"
        >
          <List
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              padding: 0,
            }}
          >
            <Stack
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
              justifyContent={"left"}
              my={2}
              mx={2}
            >
              <img
                src={MaskGroup}
                alt="Mask-Group"
                className="w-8 h-8 min-w-8 min-h-8 rounded-full"
              />
              <Typography fontWeight={600} fontSize={28}>
                Voltreum
              </Typography>
            </Stack>
            <Divider />
            {filteredSidebar.map((text, index) => (
              <React.Fragment key={index}>
                <ListItem
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={handleMouseLeave}
                  sx={{
                    color: "black",
                    borderRadius: 2,
                    backgroundColor:
                      hoveredIndex === index
                        ? "#eff7ff"
                        : hasActivePath(text, currentPath)
                          ? "#bdd2e6"
                          : "transparent",
                    cursor: "pointer",
                    transition: "background-color 0.5s ease",
                  }}
                  onClick={() => handleClick(index, text)}
                >
                  <ListItemButton sx={{ py: 1.5, color: "inherit" }}>
                    <ListItemIcon sx={{ minWidth: "40px", color: "inherit" }}>
                      {text.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={text.menu}
                      sx={{ color: "black !important" }}
                      primaryTypographyProps={{
                        fontWeight: "600 !important",
                        color: "black !important",
                      }}
                    />
                    {text.subMenu ? (
                      openIndex === index ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : null}
                  </ListItemButton>
                </ListItem>

                {text.subMenu && (
                  <Collapse
                    in={openIndex === index}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px",
                        padding: 0,
                      }}
                    >
                      {text.subMenu.map((subItem, ind) => (
                        <ListItem
                          key={ind}
                          sx={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "flex-start",
                            pl: 4,
                            pt: 0.7,
                            pb: 0.7,
                            ml: 4,
                            width: "300px",
                            backgroundColor:
                              subItem.link === currentPath
                                ? "#a3c5e4"
                                : "transparent",
                            transition: "background-color 0.3s ease",
                            "&:hover": {
                              backgroundColor: "#bbd2e7",
                            },
                            borderRadius: 2,
                          }}
                          onClick={() => handleNavigate(subItem.link)}
                        >
                          <ListItemText
                            primary={subItem.title}
                            primaryTypographyProps={{
                              fontWeight: "600 !important",
                              color: "black !important",
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Drawer>
      {!sidebarOpen && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            width: 72,
            backgroundColor: "#F8FAFD",
            borderRight: "1px solid #D3E3FD",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            py: 2,
            height: "100vh",
            overflowY: "auto",
            // hide scrollbar but keep scrollable
            "&::-webkit-scrollbar": { width: 0 },
            zIndex: (theme) => theme.zIndex.drawer - 250,
          }}
        >
          <Box sx={{ mb: 2 }} onClick={() => setSidebarOpen(true)}>
            <img
              src={MaskGroup}
              alt="Mask-Group"
              className="w-8 h-8 min-w-8 min-h-8 rounded-full"
            />
          </Box>
          <List sx={{ p: 0, width: 1, flexGrow: 1 }}>
            {filteredSidebar.map((item, idx) => (
              <React.Fragment key={idx}>
                <ListItem sx={{ p: 0, justifyContent: "center" }}>
                  <Tooltip title={item.menu} placement="right">
                    <ListItemButton
                      sx={{
                        justifyContent: "center",
                        minWidth: 0,
                        px: 1,
                        py: 1.5,
                        color: "inherit",
                        backgroundColor: hasActivePath(item, currentPath)
                          ? "#E8F3FF"
                          : "transparent",
                        borderRadius: 2,
                      }}
                      onClick={(e) => {
                        if ((item as any).subMenu) {
                          if (miniOpenIndex === idx) {
                            setMiniOpenIndex(null);
                            setMiniAnchorEl(null);
                          } else {
                            setMiniOpenIndex(idx);
                            setMiniAnchorEl(e.currentTarget);
                          }
                        } else {
                          handleClick(idx, item);
                        }
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: 0 }}>
                        {React.cloneElement(item.icon, {
                          fill: hasActivePath(item, currentPath)
                            ? "#1976D2"
                            : undefined,
                          width: "20",
                        })}
                      </ListItemIcon>
                    </ListItemButton>
                  </Tooltip>
                </ListItem>

                {(item as any).subMenu && (
                  <Popover
                    open={miniOpenIndex === idx}
                    anchorEl={miniAnchorEl}
                    onClose={() => {
                      setMiniOpenIndex(null);
                      setMiniAnchorEl(null);
                    }}
                    anchorOrigin={{ vertical: "center", horizontal: "right" }}
                    transformOrigin={{ vertical: "center", horizontal: "left" }}
                    disableAutoFocus
                    disableEnforceFocus
                    disableRestoreFocus
                    keepMounted
                    marginThreshold={0}
                    PaperProps={{
                      sx: {
                        borderRadius: 2,
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        p: 2,
                        ml: 1,
                        mt: 0,
                        m: 0,
                      },
                    }}
                  >
                    <Box>
                      {(item as any).link && (
                        <Typography
                          sx={{
                            fontSize: 16,
                            lineHeight: 1.6,
                            fontWeight: 700,
                            cursor: "pointer",
                            mb: 1,
                          }}
                          onClick={() => {
                            handleNavigate((item as any).link || "");
                            setMiniOpenIndex(null);
                            setMiniAnchorEl(null);
                          }}
                        >
                          {(item as any).menu}
                        </Typography>
                      )}
                      {!(item as any).link && (
                        <Typography
                          variant="h6"
                          fontSize={16}
                          sx={{ fontWeight: 700, mb: 1 }}
                        >
                          {(item as any).menu}
                        </Typography>
                      )}
                      <Box>
                        {(item as any).subMenu?.map(
                          (sub: any, sIdx: number) => (
                            <Typography
                              key={sIdx}
                              sx={{
                                fontSize: 16,
                                lineHeight: 1.6,
                                fontWeight:
                                  sub.link === currentPath ? 600 : 400,
                                cursor: "pointer",
                                color:
                                  sub.link === currentPath
                                    ? "#1064ED"
                                    : "#111827",
                                mb: 0.5,
                              }}
                              onClick={() => {
                                handleNavigate(sub.link);
                                setMiniOpenIndex(null);
                                setMiniAnchorEl(null);
                              }}
                            >
                              {sub.title}
                            </Typography>
                          ),
                        )}
                      </Box>
                    </Box>
                  </Popover>
                )}
              </React.Fragment>
            ))}
          </List>
        </Box>
      )}
    </div>
  );
};
//
export default Sidebar;
